
import { Logo } from "../components/logo";

export function Header() {

  return (

    <header className="px-6 sm:px-8">

      <div className="flex items-center justify-center py-4 sm:py-5 min-h-[80px]">

        <a href="https://www.biomerieux.com/">

          <Logo variant="header" />

        </a>

      </div>

    </header>

  );

}
